import React from 'react';
import { Link } from 'react-router-dom';

const EmptyOrders = () => {
  return (
    <div className='orders-empty'>
      <div className='orders-empty__title'>
        Нет ордеров...
      </div>
      <Link to='/orders/create' className='orders-empty__create'>
        Создать Ордер
      </Link>
    </div>
  )
};

export default EmptyOrders;